// extracted by mini-css-extract-plugin
export var appear = "standardLayout-module--appear--YolQT";
export var floating = "standardLayout-module--floating--hQtTu";
export var headerContainer = "standardLayout-module--headerContainer--tB222";
export var headerText = "standardLayout-module--headerText--FO1Y9";
export var innerContent = "standardLayout-module--innerContent--vWRHT";
export var pageContent = "standardLayout-module--pageContent--f67F1";
export var pageLayout = "standardLayout-module--pageLayout--xr3Nk";
export var rounded = "standardLayout-module--rounded--NGKjH";
export var roundedCorners = "standardLayout-module--rounded-corners--K1SsK";